import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTeacherProfessionalInfo, updateTeacherProfessionalInfo } from "./update-teacher-professional-info";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateTeacherProfessionalInfoReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateTeacherProfessionalInfo.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(updateTeacherProfessionalInfo.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(updateTeacherProfessionalInfo.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetUpdateTeacherProfessionalInfo, () => {
    return initialState;
  });
});
